<!--
 * @Descripttion: 
 * @Author: yuezexu
 * @Date: 2021-09-22 09:24:28
 * @LastEditors: yuezexu
 * @LastEditTime: 2021-09-22 18:02:21
-->
<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
export default {
    name: "app",
    data() {
        return {};
    },
    components: {},
    mounted() {}
};
</script>

<style>
@import url("../public/assets/style/reset.css");
@import url("../public/assets/style/common.css");

/* #app {
} */
</style>
